import { RadioControl, TabPanel, TextareaControl, TextControl, ToggleControl, PanelRow } from '@wordpress/components'
import { __ } from '@wordpress/i18n'
import { useSelect, dispatch } from '@wordpress/data'

export default function InventoryTabContent( {allData} ) {
    const { updateTripData } = dispatch('WPTravel/TripEdit')
    let inventoryData = 'undefined' != typeof allData && 'undefined' != typeof allData.inventory ? allData.inventory : []
    const {
        enable_trip_inventory: isInventoryEnabled,
        inventory_counts_paid_only,
        wp_travel_inventory_status_message_format: statusMessageFormat,
        wp_travel_inventory_pax_limit_type: paxLimit,
        wp_travel_inventory_custom_max_pax: maxPaxNumber,
        wp_travel_inventory_sold_out_message: soldOutMessage,
        wp_travel_inventory_sold_out_action: outOfStockOption,
        wp_travel_inventory_size: inventorySize
    } = inventoryData

    const handleChange = (name, type) => {
        if (type && type.match(/(toggle|checkbox)/)) {
            return () => updateTripData({
                ...allData,
                inventory: {
                    ...allData.inventory,
                    [name]: 'yes' === allData.inventory[name] ? 'no' : 'yes'
                }
            })
        }
        return (value) => {
            updateTripData({
                ...allData,
                inventory: {
                    ...allData.inventory,
                    [name]: value
                }
            })
        }
    }

    return <>
        <PanelRow>
            <label>{__('Enable Trip Inventory')}</label>
            <ToggleControl
                help={__('Enable to activate inventory features for this trip !!')}
                checked={'yes' === isInventoryEnabled}
                onChange={handleChange('enable_trip_inventory', 'toggle')} />
        </PanelRow>
        {'yes' === isInventoryEnabled &&
            <>
                <PanelRow>
                    <label>{__('Count Paid Booking for inventory')}</label>
                    <ToggleControl
                        help={
                            'yes' === inventory_counts_paid_only ?
                            __('Disabling this feature will count inventory for booking only along with booking with payment') : __( 'Enabling this will only allow to count inventory for paid bookings' )
                        }
                        checked={'yes' === inventory_counts_paid_only}
                        onChange={handleChange('inventory_counts_paid_only', 'toggle')} />
                </PanelRow>
                <PanelRow>
                    <label>{__('Inventory size')}</label>
                    <TextControl
                    value={inventorySize}
                    type="number"
                    required={true}
                    min="1"
                    onChange={handleChange('wp_travel_inventory_size')}
                /></PanelRow>
                <PanelRow>
                    <label>{__('OUT OF STOCK Options')}</label>
                    <RadioControl
                        selected={outOfStockOption}
                        options={[
                            { label: __('Display Enquiry Button'), value: 'allow_trip_enquiry' },
                            { label: __('Show "SOLD OUT" Message'), value: 'show_sold_out_msg_only' },
                        ]}
                        onChange={handleChange('wp_travel_inventory_sold_out_action')}
                    />
                </PanelRow>
                {'show_sold_out_msg_only' === outOfStockOption && <PanelRow>
                    <label>{__('Sold out message.')}</label>
                    <TextareaControl
                    value={soldOutMessage}
                    help={__('Custom message for unavailable trips!!')}
                    onChange={handleChange('wp_travel_inventory_sold_out_message')}
                /></PanelRow>}
            </>}
    </>
}